import routes from "@/modules/foz_chapeco/routes";
import fozChapeco from "@/modules/foz_chapeco/store";

export default {
  install(Vue, { store, router }) {
    router.addRoutes(routes);
    store.registerModule("foz_chapeco", fozChapeco);
  }
};
